/* eslint-disable react/react-in-jsx-scope */
import { specMarkDownParser } from '../helpers/markDownRender/specMarkDownParser';

const showmore = (data, btn = false) => {
  var id = Math.random().toString().replace('.', '');
  btn = false;
  return `
    <div class='box'>
    ${btn
      ? `<input onchange="if(this.checked === true) { 
              document.getElementById('${id}-showmore-label-less').style.display = 'block';
              document.getElementById('${id}-showmore-label-more').style.display = 'none';
            }else{ 
              document.getElementById('${id}-showmore-label-less').style.display = 'none'; 
              document.getElementById('${id}-showmore-label-more').style.display = 'block'
            }
          " type="checkbox" class="showmorebtn" id="${id}" />`
      : ''
    }
    <div class='showmore-body'>${specMarkDownParser(data)}</div>
    ${btn
      ? `<label for="${id}" id='${id}-showmore-label-more' style="display:block">Show more</label>`
      : ''
    }
    ${btn
      ? `<label for="${id}" id='${id}-showmore-label-less' style="display:none">Show less</label>`
      : ''
    }
    </div>`;
};
export { showmore };
